export default {
  getPaymentUrl(state) {
    return state.paymentUrl;
  },
  getSuccessPaymentUrl(state) {
    return state.successPaymentUrl;
  },
};
